import React from "react"
import { connect } from "react-redux"
import { autocompleteTopicsRequest } from "../../../../actions/autocomplete-actions"

import SelectTags from "../../../common/tags/SelectTags"

const EditFeedItemInsightDetails = ({
    topics,
    onValueChange,
    onEventChange,
    onTopicsSearch
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />Insight areas
        </h3>
        <div className="widget-content visible">
            <SelectTags
                name="topics"
                value={topics}
                loadOptions={onTopicsSearch}
                onChange={onValueChange("topics")}
            />
        </div>
    </div>
)

const mapStateToProps = (state, { topics }) => ({
    topics
})

const mapDispatchToProps = (dispatch, { onEventChange, onValueChange }) => ({
    onEventChange,
    onValueChange,
    onTopicsSearch: (searchTerm, callback) => {
        dispatch(autocompleteTopicsRequest(searchTerm, callback))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(
    EditFeedItemInsightDetails
)
